import {DomainObject} from 'shared/store';
import {observable, action, computed} from 'mobx';
import TimeOffType from './TimeOffType';
import _ from 'lodash';

class TimeOffAccount extends DomainObject {
  @observable id;
  @observable timeOffType;
  @observable balance;
  @observable unlimited;

  @action merge(other) {
    super.merge(other, {
      timeOffType: TimeOffType
    });
  }

  @computed get balanceView() {
    if (this.unlimited) return '--';

    return this.balance;
  }

  @computed get isNegativeBalance() {
    if (this.unlimited) return false;

    return this.balance < 0;
  }

  @computed get balanceDescription() {
    return this.unlimited ? 'employees.profile.time_off.Flexible' : `employees.profile.time_off.${_.startCase(this.timeOffType.unit)} Available`;
  }
}

export default TimeOffAccount;
